var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAddPhoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49 13.7188V41.2812C49 43.8174 46.9424 45.875 44.4062 45.875H4.59375C2.05762 45.875 0 43.8174 0 41.2812V13.7188C0 11.1826 2.05762 9.125 4.59375 9.125H13.0156L14.1928 5.97637C14.8627 4.18672 16.5758 3 18.4898 3H30.5006C32.4146 3 34.1277 4.18672 34.7977 5.97637L35.9844 9.125H44.4062C46.9424 9.125 49 11.1826 49 13.7188ZM35.9844 27.5C35.9844 21.1645 30.8355 16.0156 24.5 16.0156C18.1645 16.0156 13.0156 21.1645 13.0156 27.5C13.0156 33.8355 18.1645 38.9844 24.5 38.9844C30.8355 38.9844 35.9844 33.8355 35.9844 27.5ZM32.9219 27.5C32.9219 32.1416 29.1416 35.9219 24.5 35.9219C19.8584 35.9219 16.0781 32.1416 16.0781 27.5C16.0781 22.8584 19.8584 19.0781 24.5 19.0781C29.1416 19.0781 32.9219 22.8584 32.9219 27.5Z",
    fill: "#374957"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAddPhoto);
export default __webpack_public_path__ + "static/media/iconAddPhoto.a7366ad44b5e7e4a7d64ec200723dc3a.svg";
export { ForwardRef as ReactComponent };